import { getAugmentedNamespace as e } from "./_commonjsHelpers.js";
import * as t from "../external/react-lifecycles-compat/react-lifecycles-compat.es.js";
const a = /* @__PURE__ */ e(t);
export {
  a as default
};
